import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    setTimeout(() => window.scrollTo({ top: 0 }));
  }, [pathname]);

  return null;
}
